export enum SidebarContext {
  Layers = 'layers',
  Filters = 'Filters',
  Connections = 'Connections',
  Changeset = 'Changeset',
  History = 'History',
  Menu = 'Menu',
  SelectedFeature = 'SelectedFeature',
  Print = 'Print',
  Journal = 'Journal'
}
